module.exports = __webpack_public_path__ + "img/the-netherlands-cerebrovascular-disease-male.cacc60f9.png";